module.exports = __webpack_public_path__ + "static/img/preview-03.c4c1695f.webp";